<template lang="pug">
  v-stepper(v-model="e1")
    v-stepper-header
      v-stepper-step(:complete="e1 > 1" step="1") Detail Izin
      v-divider
      v-stepper-step(:complete="e1 > 2" step="2") Detail Pekerjaan
      v-divider
      v-stepper-step(:complete="e1 > 3" step="3") Pencegahan/Persyaratan Khusus
    v-stepper-items
      v-stepper-content(step="1")
        v-card(class="mb-12"
          height="auto")
            v-layout(row wrap)              
              v-flex(xs4 sm3 style="margin-top:20px")
                p(class="headerSection") 
                  span(class="mustFill") *
                  span  Judul Pekerjaan
              v-flex(xs7 sm5 style="margin-top:20px")
                v-text-field(id="fjp-judul-pekerjaan" class="inputDefault" v-model='ipJudulPekerjaan' label="Judul Pekerjaan")
              v-flex(xs1 sm4)

              v-flex(xs4 sm3)
                p(class="headerSection") 
                  span(class="mustFill") *
                  span  Jenis Pekerjaan
              v-flex(xs7 sm5)
                v-autocomplete(
                  id="fjp-jenis-pekerjaan"
                  class="inputDefault"
                  v-model="ipJenisPekerjaan"
                  :items="jobsTypes"
                  label="Jenis Pekerjaan"
                  chips
                  clearable
                  multiple)
              v-flex(xs1 sm4)

              v-flex(xs4 sm3)
                p(class="headerSection") 
                  span(class="mustFill") *
                  span  Zona Kerja
              v-flex(xs7 sm5)
                v-autocomplete(
                  class="inputDefault"
                  id="fjp-zona-kerja"
                  multiple
                  v-model="ipZonaKerja"
                  :items="valZona"
                  chips
                  clearable
                  label="Zona Kerja")
              v-flex(xs1 sm4)

              v-flex(xs4 sm3) 
                p(class="headerSection") 
                  span(class="mustFill") *
                  span  Lokasi
              v-flex(xs7 sm5)
                    v-autocomplete(
                      class="inputDefault"
                      label="Lokasi" 
                      id="fjp-lokasi"
                      v-model="lokasi" 
                      :items="locations.data" 
                      no-data-text="No Data" 
                      color="blue-grey lighten-2" 
                      item-text="location_name" 
                      item-value="data" 
                      clearable
                      chips
                      multiple)
              v-flex(xs1 sm4)
              v-flex(xs4 sm3)
                p(class="headerSection") 
                  span(class="mustFill") *
                  span  Sublokasi
              v-flex(xs7 sm5)
                  v-text-field(id="fjp-sub-lokasi" class="inputDefault" v-model='ipSubLocation' label="Sub Lokasi" counter="100" maxlength="100")
              v-flex(xs1 sm4)
              v-flex(xs4 sm3) 
                p(class="headerSection") 
                  span(class="mustFill") *
                  span  Estimasi Waktu Pekerjaan
              v-flex(xs4 sm2)
                v-menu(
                  v-model="startMenuEstimasi"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  id="fjp-estimasi-start-menu")
                
                  template(v-slot:activator="{ on }")
                    v-text-field(
                      v-model="startDate"
                      label="mulai dari"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                      id="fjp-estimasi-start-input")
                  v-date-picker(id="fjp-estimasi-start-picker" v-model="startDate" @input="clearDate" :min="estimateMinDate" :allowed-dates="estimateAllowedDatesStart")
              v-flex(xs4 sm2)
                v-menu(
                  v-model="endMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  id="fjp-estimasi-end-menu")
                
                  template(v-slot:activator="{ on }")
                    v-text-field(
                      v-model="endDate"
                      label="sampai dengan"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                      id="fjp-estimasi-end-input")
                  v-date-picker(show-current="false" v-model="endDate" @input="endMenu = false" :min="startDate || estimateMinDate" :allowed-dates="estimateAllowedDatesEnd" id="fjp-estimasi-end-picker")
              
              v-flex(xs0 sm4) 
              v-flex(xs4 sm3 style="margin-top:10px") 
                  p(class="headerSection") 
                    span(class="mustFill") *
                    span  Pengawas Melekat (Waskat)
                    div(
                      class="font-italic grey--text ml-6 mt-n3"
                      style="font-size: 13px;"
                    ) Wajib mengisi Waskat 1 dan Waskat 2
              v-flex(xs7 sm5 style="margin-top:10px")
                  v-menu(
                    v-model="searchWaskatMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px")
                  
                    template(v-slot:activator="{ on }")
                      v-text-field(
                        style="margin-top:-19px;"
                        v-model="waskat.name"
                        id="fjp-waskat1"
                        label="Pilih Waskat 1"
                        readonly
                        v-on="on")
                    PemegangModal(:searchPemegang="searchWaskatMenu" @interface="searchWaskatMenu = false" @selectedUser="updateWaskat")
              v-flex(xs1 sm4)
              
              v-flex(v-if="waskat" xs4 sm3) 
              v-flex(v-if="waskat" xs7 sm5 style="margin-top:-10px;margin-bottom:10px")
                  ModalEditDataWaskat( 
                    :editWaskat="waskat" 
                    :openModal="openModalEditWaskat"
                    @onClose="closeModalEditWaskat" 
                    @handleSaveData="saveEditWaskat"
                    ref="modalEditWaskat1"
                  )
                  label(style="font-style: italic;font-size:14px") No HP : {{waskat.contact}}

                  div(
                    class="red--text" 
                    style="font-size:14px"
                    v-if="!waskat.contact"
                  ) {{ invalid_phone }}

                  v-btn(text 
                    color="primary" 
                    style="font-style: italic;font-size:14px;float:right;text-transform: capitalize"
                    @click="handleOpenModal()") Edit
                  br
                  label(style="font-style: italic;font-size:14px") Email : {{ waskat.email}}

                  div(
                    class="red--text" 
                    style="font-size:14px"
                    v-if="!waskat.email"
                  ) {{ invalid_email }}

              v-flex(v-if="waskat" xs1 sm4)

              v-flex(xs4 sm3 style="margin-top:20px") 
              v-flex(xs7 sm5 style="margin-top:20px")
                  v-menu(
                    v-model="searchWaskat2Menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px")
                  
                    template(v-slot:activator="{ on }")
                      v-text-field(
                        style="margin-top:-19px;"
                        v-model="waskat2.name"
                        id="fjp-waskat2"
                        label="Pilih Waskat 2"
                        readonly
                        v-on="on")
                    PemegangModal(:searchPemegang="searchWaskat2Menu" @interface="searchWaskat2Menu = false" @selectedUser="updateWaskat2")
              v-flex(xs1 sm4)

              v-flex(v-if="waskat2" xs4 sm3) 
              v-flex(v-if="waskat2" xs7 sm5 style="margin-top:-10px;margin-bottom:10px")
                  ModalEditDataWaskat2( 
                    :editWaskat2="waskat2" 
                    :openModal="openModalEditWaskat2"
                    @onClose="closeModalEditWaskat2" 
                    @handleSaveData="saveEditWaskat2"
                    ref="modalEditWaskat2"
                  )
                  label(style="font-style: italic;font-size:14px") No HP : {{waskat2.contact}}

                  div(
                    class="red--text" 
                    style="font-size:14px"
                    v-if="!waskat2.contact"
                  ) {{ invalid_phone }}

                  v-btn(text 
                    color="primary" 
                    style="font-style: italic;font-size:14px;float:right;text-transform: capitalize"
                    @click="handleOpenModal2()") Edit
                  br
                  label(style="font-style: italic;font-size:14px") Email : {{ waskat2.email}}

                  div(
                    class="red--text" 
                    style="font-size:14px"
                    v-if="!waskat2.email"
                  ) {{ invalid_email }}

              v-flex(v-if="waskat2" xs1 sm4)

              v-flex(xs4 sm3 style="margin-top:20px") 
              v-flex(xs7 sm5 style="margin-top:20px")
                  v-menu(
                    v-model="searchWaskat3Menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                    
                    )
                  
                    template(v-slot:activator="{ on }")
                      v-text-field(
                        style="margin-top:-19px;"
                        v-model="waskat3.name"
                        id="fjp-waskat3"
                        label="Pilih Waskat 3 (Optional)"
                        readonly
                        v-on="on"
                        :disabled="!waskat && !waskat2 ? true : false"
                        clearable
                        @click:clear="clearWaskat3"
                        )
                    PemegangModal(:searchPemegang="searchWaskat3Menu" @interface="searchWaskat3Menu = false" @selectedUser="updateWaskat3")
              v-flex(xs1 sm4)  

              v-flex(v-if="waskat3" xs4 sm3) 
              v-flex(v-if="waskat3" xs7 sm5 style="margin-top:-10px;margin-bottom:10px")
                  ModalEditDataWaskat3( 
                    :editWaskat3="waskat3" 
                    :openModal="openModalEditWaskat3"
                    @onClose="closeModalEditWaskat3" 
                    @handleSaveData="saveEditWaskat3"
                    ref="modalEditWaskat3"
                  )
                  label(style="font-style: italic;font-size:14px") No HP : {{waskat3.contact}}

                  div(
                    class="red--text" 
                    style="font-size:14px"
                    v-if="!waskat3.contact"
                  ) {{ invalid_phone }}

                  v-btn(text 
                    color="primary" 
                    style="font-style: italic;font-size:14px;float:right;text-transform: capitalize"
                    @click="handleOpenModal3()") Edit
                  br
                  label(style="font-style: italic;font-size:14px") Email : {{ waskat3.email}}

                  div(
                    class="red--text" 
                    style="font-size:14px"
                    v-if="!waskat3.email"
                  ) {{ invalid_email }}

              v-flex(v-if="waskat3" xs1 sm4)

        //- v-btn(color="primary" @click="e1 = 2; scrollTop();" ) Continue
        v-btn(color="primary" @click="e1 = 2; scrollTop();" :disabled='!isPage1Complete') Continue
        v-btn(text @click="backHome()") Cancel

      v-stepper-content(step="2")
        ModalNotifWaskat( :openModalNotif="openModalNotif", @onClose="closeModal")
        v-card(class="mb-12"
          height="auto")
            v-layout(row wrap)
              v-flex(xs7 sm8 style="margin-top:20px;padding-left:20px")
                //- v-autocomplete(
                //-   id="fjp-search-pekerjaan"   
                //-   v-model="karyawanValues"
                //-   :items="dataKaryawan"
                //-   outlined
                //-   :loading ="isLoadingSearch"
                //-   hide-selected
                //-   clearable
                //-   dense
                //-   item-text="name"
                //-   item-value="_id"
                //-   :search-input.sync="searchName"
                //-   append-outer-icon ="mdi-magnify"
                //-   label="Search nama Pekerja"
                //-   @click:clear="clearKaryawan"
                //-   return-object
                //-   )
                //-   template(v-slot:no-data)
                //-     v-list-item()
                //-       v-list-item-title Masukkan kata kunci yang sesuai
                //-   template(v-slot:item="{ item }") {{ item.name }} - {{ item.ktpNumber }}
              
              v-flex(xs12)
                v-layout(row wrap, style="margin-right: unset; margin-left: unset;")
                  v-flex(xs4 sm3)
                    p(class="headerSection") 
                      span(class="mustFill") *
                      span  Photo
                      small(class="d-block ms-3") file format harus png, jpg atau jpeg
                  v-flex(xs7 sm5 v-if="!photo || photo.size > 10000000")
                    v-file-input(
                      :rules="rules"
                      accept=".png,.jpg,.jpeg,.JPG,.PNG,.JPEG"
                      placeholder="Upload Photo"
                      prepend-icon="mdi-camera"
                      label="Photo"
                      class="inputDefault"
                      v-model="photo"
                      id="fjp-upload-photo"
                    )
                      template(v-slot:selection="{ text }" )
                        v-chip(small label color="primary")   {{ text }}
                  v-flex(id="fjp-upload-photo-sukses" xs7 sm5 class="attachmentName" v-else-if="(photo)||(photo && photo.size < 10000000)")
                    span {{photo.name ? photo.name : docName(photo) }}
                    v-btn(icon color="red" @click="deleteDocPendukung('photo')")
                      v-icon mdi-close

              v-flex(xs4 sm3)
                p(class="headerSection") 
                  span(class="mustFill") *
                  span  Nama Lengkap
              v-flex(xs7 sm5)
                v-text-field(id="fjp-nama-lengkap" class="inputDefault" v-model='ipKaryawan.name' label="Nama Lengkap")
              v-flex(xs1 sm4)

              //- v-flex(xs4 sm3)
              //-   p(class="headerSection") 
              //-     span(class="mustFill") *
              //-     span  Nama Panggilan
              //- v-flex(xs7 sm5)
              //-   v-text-field(id="fjp-nama-panggilan" class="inputDefault" v-model='ipKaryawan.nickname' label=" Nama Panggilan")
              //- v-flex(xs1 sm4)

              v-flex(xs4 sm3) 
                p(class="headerSection") 
                  span(class="mustFill") *
                  span  Tempat / Tanggal Lahir
              v-flex(xs4 sm2)
                v-text-field(id="fjp-tempat-lahir" class="inputDefault" v-model='ipKaryawan.birthPlace' label="Tempat Lahir")
              v-flex(xs4 sm3)
                v-menu(
                  v-model="startMenu"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                     :close-on-content-click="false"
                  )

                  template(v-slot:activator="{ on }")
                    v-text-field(
                      v-model="ipKaryawan.birthDate"
                      label="Tanggal"
                      id="fjp-birth-date"
                      prepend-icon="event"
                      readonly
                      style="margin-top:-19px;"
                      v-on="on"
                      )
                  v-date-picker(v-model="ipKaryawan.birthDate"  @input="startMenu = false")
              v-flex(xs1 sm4)

              v-flex(xs4 sm3)
                p(class="headerSection") 
                  span(class="mustFill") *
                  span  Jabatan/Posisi
              v-flex(xs7 sm5)
                v-text-field(id="fjp-jabatan" class="inputDefault" v-model='ipKaryawan.position' label=" Jabatan/Posisi")
              v-flex(xs1 sm4)

              v-flex(xs4 sm3) 
                p(class="headerSection") 
                  span(class="mustFill") *
                  span  Perusahaan
              v-flex(xs7 sm5)
                v-autocomplete(
                  class="inputDefault"
                  id="fjp-perusahaan"
                  label="Perusahaan" 
                  v-model="company" 
                  :items="companiesVal" 
                  no-data-text="No Data" 
                  color="blue-grey lighten-2" 
                  item-text="location_name" 
                  item-value="data")
              v-flex(xs1 sm4)

              v-flex(xs4 sm3 v-if="company == 'Lain-Lain'") 
              v-flex(xs4 sm2 v-if="company == 'Lain-Lain'")
                v-text-field(id="fjp-perusahaan2" class="inputDefault" v-model='otherCompany' label="* Perusahaan")
              v-flex(xs4 sm3 v-if="company == 'Lain-Lain'")
                v-text-field(id="fjp-nm-atasan" class="inputDefault" style="padding-left:40px" v-model='atasan.name' label="* Nama Atasan")
              v-flex(xs1 sm4 v-if="company == 'Lain-Lain'")
              
              v-flex(xs4 sm3 v-if="company == 'Lain-Lain'") 
              v-flex(xs4 sm2 v-if="company == 'Lain-Lain'")
                v-text-field(id="fjp-email-atasan" class="inputDefault" v-model='atasan.email' label="* Email Atasan"  :rules='[visitorRules.required, visitorRules.email]')
              v-flex(xs4 sm3 v-if="company == 'Lain-Lain'")
               v-text-field(id="fjp-n0-telp-atasan" class="inputDefault" style="padding-left:40px" v-model='atasan.phone' :maxlength='phoneNumLength' :rules='[visitorRules.required, visitorRules.phone]' label="* Nomor Telepon Atasan")
              v-flex(xs1 sm4 v-if="company == 'Lain-Lain'")

              v-flex(xs4 sm3 style="margin-top:25px") 
                p(class="headerSection") 
                  span(class="mustFill") *
                  span  Departemen 
              v-flex(xs7 sm5 style="margin-top:25px")
                v-autocomplete(
                  id="fjp-department"
                  class="inputDefault"
                  v-model="ipKaryawan.department"
                  :items="dataUsers.department"
                  label="Departemen")          
              v-flex(xs1 sm4)

              v-flex(xs4 sm3) 
                p(class="headerSection") 
                  span(class="mustFill") *
                  span  Golongan Darah
              v-flex(xs11 sm5)
                v-autocomplete(
                  id="fjp-golongan-darah"
                  class="inputDefault"
                  v-model="ipKaryawan.bloodType"
                  :items="golonganDarahList"
                  label="Golongan Darah")
              v-flex(xs1 sm4)

              v-flex(xs4 sm3 style="margin-top:10px")
                p(class="headerSection") 
                  span(class="mustFill") *
                  span  No KTP
              v-flex(xs7 sm5 style="margin-top:10px")
                v-text-field(id="fjp-no-ktp" class="inputDefault" v-model='ipKaryawan.ktpNumber' label=" No KTP"  maxlength=16
                      :rules="[value => value.length <= 16 || 'Max 16 characters', visitorRules.ktp]")
              v-flex(xs1 sm4)

              v-flex(xs4 sm3 style="margin-top:16px")
                p(class="headerSection") 
                  span(class="mustFill") *
                  span  No HP
                br
              v-flex(xs7 sm5 style="margin-top:16px")
                v-text-field(:error-messages="errorNotif" id="fjp-no-hp" class="inputDefault" :rules='[visitorRules.phone, visitorRules.required]' v-model='ipKaryawan.phone' label=" No HP" :counter='phoneNumLength' :maxlength='phoneNumLength')
              v-flex(xs1 sm4)

              v-flex(xs4 sm3  style="margin-top:10px")
                p(class="headerSection") 
                  span(class="mustFill") *
                  span  Kontak Darurat (Keluarga)
                br
              v-flex(xs7 sm5 style="margin-top:10px")
                v-text-field(:error-messages="errorNotif" id="fjp-kontak-darurat" class="inputDefault" :rules='[visitorRules.phone, visitorRules.required]' v-model='ipKaryawan.emergencyPhone' label=" Kontak Darurat (Keluarga)" :counter='phoneNumLength' :maxlength='phoneNumLength')
              v-flex(xs1 sm4)

              v-flex(xs4 sm3 style="margin-top:10px")
                p(class="headerSection") 
                  span(class="mustFill") *
                  span  Email
              v-flex(xs7 sm5 style="margin-top:10px")
                v-text-field(id="fjp-email" class="inputDefault" v-model='ipKaryawan.email' label=" Email"  :rules='[visitorRules.required, visitorRules.email]')
              v-flex(xs1 sm4)

              v-flex(xs12 sm12) 
                h3(class="headerSection") Deskripsi Detail Pekerjaan 
                br
              v-flex( sm12)
                div(style="margin: 0 15px 0 15px;padding: 0;}")
                  ckeditor(id="fjp-detail-pekerjaan" :editor="editor" v-model="ipJobDescription" :config="editorConfig")
                br

        v-btn(class="mr-3" dark color='blue-grey' @click="backStep();scrollTop();") BACK
        //- v-btn(color="primary" @click="e1 = 3; scrollTop();" ) Submit
        v-btn(color="primary" @click="handleNextStep(); scrollTop();" :disabled='!isPage2Complete') Continue
        v-btn(text @click="backHome()") Cancel

      v-stepper-content(step="3")
        v-card(class="mb-12"
          height="auto")
            v-layout(row wrap)
              v-flex(xs4 sm8)
                h3(style="margin-left:15px;margin-bottom:15px")  LAMPIRAN
              v-flex(xs1 sm4)

              v-flex(xs4 sm3) 
                p(class="headerSection") 
                  span  Surat-surat dari Dokter 
              v-flex(xs7 sm5)
              v-flex(xs7 sm3)
                v-autocomplete(
                  id="fjp-surat-doket"
                  class="inputDefault"
                  v-model="ipUploadedDocsStatus.doctorStatement"
                  :items="doctorStateVal"
                  clearable
                  label="Pilih")          
              v-flex(xs1 sm1)

              v-flex(xs4 sm3) 
                p(class="headerSection") 
                  span  Salinan KTP
              v-flex(xs7 sm5)
              v-flex(xs7 sm3)
                v-autocomplete(
                  id="fjp-salinan-ktp"
                  class="inputDefault"
                  v-model="ipUploadedDocsStatus.ktpCopy"
                  :items="ktpCopyVal"
                  clearable
                  label="Pilih")          
              v-flex(xs1 sm1)

              v-flex(xs4 sm3) 
                p(class="headerSection") 
                  span  JSA/AKA yang sudah disosialisasi
              v-flex(xs7 sm5)
              v-flex(xs7 sm3)
                v-autocomplete(
                  id="fjp-jsa"
                  class="inputDefault"
                  v-model="ipUploadedDocsStatus.jsaAka"
                  :items="jsaAkaVal"
                  clearable
                  label="Pilih")          
              v-flex(xs1 sm1)

              v-flex(xs4 sm3) 
                p(class="headerSection") 
                  span Induksi Khusus (Jika diperlukan) 
              v-flex(xs7 sm5)
              v-flex(xs7 sm3)
                v-autocomplete(
                  id="fjp-induksi-khusus"
                  class="inputDefault"
                  v-model="ipUploadedDocsStatus.specialInduction"
                  :items="specialInducVal"
                  clearable
                  label="Pilih")          
              v-flex(xs1 sm1)

              v-flex(xs4 sm3) 
                p(class="headerSection") 
                  span  Berkas Lain-lain 
              v-flex(xs7 sm5)
              v-flex(xs7 sm3)
                v-autocomplete(
                  id="fjp-berkas"
                  class="inputDefault"
                  v-model="ipUploadedDocsStatus.other"
                  :items="otherVal"
                  clearable
                  label="Pilih")          
              v-flex(xs1 sm1)

              v-flex(xs5 sm3) 
                h3(class="headerSection") Upload Dokumen
              v-flex(xs6 sm3 class="attachment" v-if="!docPendukung || docPendukung.size > 10000000")
                v-file-input(id="fjp-upload-dokumen" :rules="rules"  label="Hanya 1 file, max 10MB" v-model="docPendukung")
                  template(v-slot:selection="{ text }" )
                    v-chip(small label color="primary")   {{ text }}
              v-flex(id="fjp-upload-dokumen-sukses" xs6 sm3 class="attachmentName" v-else-if="(docPendukung)||(docPendukung && docPendukung.size < 10000000)")
                span {{docPendukung.name ? docPendukung.name : docName(docPendukung) }}
                v-btn(icon color="red" @click="deleteDocPendukung('docPendukung')")
                  v-icon mdi-close
              v-flex(xs1 sm4)
              v-flex(xs5 sm3)
              h3 ⠀

        v-btn(class="mr-3" dark color='blue-grey' @click="backStep();scrollTop();") BACK
        v-btn(class="mr-3" color='info' @click='submit(1)')
          v-icon insert_drive_file
          | &nbsp; Save as Draft
        v-btn( color='success' @click='submit(2)')
          v-icon send
          | &nbsp; Submit Request
        v-btn(text @click="backHome()") Cancel

        v-row(justify="center")
        ModalValidasiWaskat(
          v-model="dialogInfo"
          :karyawan="ipKaryawan"
          :dataValidasi="ipValidasiWaskat"
          :company="company"
          :other-company="otherCompany"
        )
        
</template>

<script>
import helper from "../helper/index.js";
import axios from "axios";
import { mapState } from "vuex";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { MyCustomUploadAdapterPlugin } from "../utils/MyUploadAdapter";
import PemegangModal from "./PemegangModal.vue";
import moment from "moment";
import ModalNotifWaskat from "./ModalNotifWaskat.vue";
import ModalEditDataWaskat from "./ModalEditDataWaskat.vue";
import ModalEditDataWaskat2 from "./ModalEditDataWaskat2.vue";
import ModalEditDataWaskat3 from "./ModalEditDataWaskat3.vue";
import ModalValidasiWaskat from './ModalValidasiWaskat.vue'

export default {
  name: "AddJangkaPendek",
  components: {
    ModalValidasiWaskat,
    PemegangModal,
    ModalNotifWaskat,
    ModalEditDataWaskat,
    ModalEditDataWaskat2,
    ModalEditDataWaskat3
  },
  props: {
    edit: { type: Boolean, default: false },
    users: Array,
  },
  data() {
    return {
      dialogInfo: false,
      e1: 1,
      phoneNumLength: 15,
      editor: ClassicEditor,
      editorConfig: {
        extraPlugins: [MyCustomUploadAdapterPlugin],
        removePlugins: ["ImageUpload", "MediaEmbed"],
        toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'indent', 'outdent', '|', 'blockQuote', 'insertTable', 'undo', 'redo'],
        image: {
          // You need to configure the image toolbar, too, so it uses the new style buttons.
          toolbar: [
            "imageTextAlternative",
            "|",
            "imageStyle:alignLeft",
            "imageStyle:full",
            "imageStyle:alignRight",
          ],
          styles: [
            // This option is equal to a situation where no style is applied.
            "full",
            // This represents an image aligned to the left.
            "alignLeft",
            // This represents an image aligned to the right.
            "alignRight",
          ],
        },
      },
      ipNo: "",
      ipJudulPekerjaan: "",
      ipJenisPekerjaan:[],
      ipZonaKerja: [],
      lokasi: [],
      ipSubLocation: '',
      estimateDate:[],
      startDate: null,
      endDate: null,
      waskat: "",
      waskat2: "",
      waskat3: "",
      ipJobDescription: "",
      existingKaryawanId: "",
      ipKaryawan:{
        ktpNumber :"",
        phone : "",
        emergencyPhone: "",
        email : "",
        name : "",
        //- nickname:"",
        birthPlace: "",
        birthDate :"",
        position :"",

        department :"",
        bloodType:"",
      },
      ipValidasiWaskat:{
        ipNo:"",
        department:"",
        ipEstimateEnd:"",
      },
      atasan :{
          name: "",
          email :"",
          phone:""
      },
      company :"",
      otherCompany : "",
      ipUploadedDocsStatus: {
        doctorStatement: "",
        ktpCopy: "",
        jsaAka: "",
        specialInduction: "",
        other: "",
      },
      karyawanValues:"",
      searchName :null,
      isLoadingSearch: false,
      uploadId: null,
      uploadIdPhoto: null,
      docPendukung: null,
      photo: null,
      formCode: "BIB-HSE-PPO-FRM-036-001",
      
      jobsTypes : [],
      valZona: ["Zona 0 (Mess, Kantor, Kantin)", "Zona 1, (Sepanjang jalan Haulin Kantor Tambang)", "Zona 2 (Pit, ROM, Disposal, Wshop Eksplorasi, Pond, CPP)", "Zona P (Jetty, Port & Kantor Port)"],
      golonganDarahList:["A","AB","B","O"],
      doctorStateVal :["Ya","Tidak"],
      ktpCopyVal :["Ya","Tidak"],
      jsaAkaVal :["Ya","Tidak"],
      specialInducVal :["Ya","Tidak"],
      otherVal :["Ya","Tidak"],
      companiesVal :[],
      dataKaryawan:[],
      openModalNotif : false,
      openModalEditWaskat : false,
      openModalEditWaskat2 : false,
      openModalEditWaskat3 : false,
      menu: false,
      minDate:'',
      maxDate:'',
      searchWaskatMenu: false,
      searchWaskat2Menu:false,
      searchWaskat3Menu:false,
      
      divisi: "",
      deptDivisi: "",
      perusahaan: "",      
      pengendalianRisikoTambahan: "",
      catatanPentingLain: "",
      bahaya: "",
      frekuensiUjiGas: "",
      tanggalSeksiD: "",
      waktuSeksiD: "",
      LEL: "",
      checkOptions: ["Ya", "Tidak"],
      prosedurKerja: "",
      PersonilKompeten: "",
      pengamatKebakaran: "",
      materialMudahTerbakar: "",
      pengujianGas: "",
      areaDibasahkan: "",
      potensiPercikan: "",
      selimutApi: "",
      rambuTerpasang: "",
      areaBarikade: "",
      pemeriksaanApi: "",
      APAR: "",
      todayDate: new Date().toISOString().slice(0, 10),

      startMenu: false,
      endMenu: false,
      birthDate: [],
      tglPengajuan: null,
      startMenuPengajuan: false,
      startMenuEstimasi: false,
      startDateExtend: new Date().toISOString().substr(0, 10),
      endDateExtend: new Date().toISOString().substr(0, 10),
      startMenuExtend: false,
      endMenuExtend: false,


      status: 0,
      rules: [
        (value) =>
          !value || value.size < 10000000 || "Ukuran file harus dibawah 10 MB!",
      ],
      errorNotif: null,
      emptyUpload: new File([""], "", {
        type: "",
      }),
      invalid_email: "Silahkan Lengkapi Email",
      invalid_phone: "Silahkan Lengkapi No. HP"
    };
  },
  mounted: async function () {
    this.$store.dispatch("fetchLocations");
    this.$store.dispatch("fetchDataJobTypes")
    this.uploadId = JSON.stringify(Date.now());
    this.uploadIdPhoto = JSON.stringify(Date.now()+1);
    this.companiesVal = [...this.dataUsers.companies , "Lain-Lain"]
  },
  computed: {
    ...mapState(["API_URL", "locations", "dataUsers", "dataEditRequest","dataJobTypes", 'visitorRules', "waskatData"]),
    emergencyPhone() {
      return this.ipKaryawan.emergencyPhone;
    },
    mainPhone() {
      return this.ipKaryawan.phone;
    },
    selectedLoc() {
      let tempLoc = [];
      let locationCode;

      if (this.dataUsers.location instanceof Array) {
        locationCode = this.dataUsers.location[0];
      } else {
        locationCode = this.dataUsers.location;
      }

      for (let i = 0; i < this.lokasi.length; i++) {
        tempLoc.push({ code: locationCode, name: this.lokasi[i] });
      }
      return tempLoc;
    },
    waktuSeksiDMask: {
      get() {
        return this.waktuSeksiD;
      },
      set(value) {
        this.waktuSeksiD = this.filterTime(value);
      },
    },
    isPage1Complete: function () {
      return (
        !!this.ipJudulPekerjaan &&
        !(this.ipJenisPekerjaan.length < 1) &&
        !(this.ipZonaKerja.length < 1 )&&
        !(this.lokasi.length < 1) && !!this.ipSubLocation && this.startDate && this.endDate &&
        this.waskat.contact &&
        this.waskat.email &&
        this.waskat2.contact &&
        this.waskat2.email &&
        (this.waskat3 ? (this.waskat3.contact && this.waskat3.email) : true)
      );
    },
    isPage2Complete: function () {
      const logic = (
        this.photo &&
        (this.ipKaryawan.phone && (this.visitorRules.phone(this.ipKaryawan.phone) != 'Invalid Phone Number Format') && !this.errorNotif) && 
        (this.ipKaryawan.emergencyPhone && (this.visitorRules.phone(this.ipKaryawan.emergencyPhone) != 'Invalid Phone Number Format') && !this.errorNotif) &&
        !!this.ipKaryawan.name &&
        //- !!this.ipKaryawan.nickname &&
        !!this.ipKaryawan.birthPlace &&
        !!this.ipKaryawan.birthDate && !!this.ipKaryawan.position && !!this.company &&
        !!this.ipKaryawan.department && !!this.ipKaryawan.bloodType && 
        !!this.ipKaryawan.ktpNumber && 
        (this.ipKaryawan.email && (this.visitorRules.email(this.ipKaryawan.email) != 'Invalid e-mail.')));
      return this.company == 'Lain-Lain' ?
      logic && this.atasan.name
      && (this.atasan.email && (this.visitorRules.email(this.atasan.email) != 'Invalid e-mail.'))
      && (this.atasan.phone && (this.visitorRules.phone(this.atasan.phone) != 'Invalid Phone Number Format'))
      && this.otherCompany : logic;
    },
    estimateMinDate: function () {
      return moment().format('YYYY-MM-DD');
    },
  },

  methods: {
    clearWaskat3() {
      this.waskat3 = '';
    },
    clearKaryawan() {
      this.ipKaryawan = {
        ktpNumber :"",
        phone : "",
        emergencyPhone: "",
        email : "",
        name : "",
        //- nickname:"",
        birthPlace: "",
        birthDate :"",
        position :"",

        department :"",
        bloodType:"",
      };
      this.existingKaryawanId = "";
      this.company = "";
      this.otherCompany = "";
      this.atasan = {
          name: "",
          email :"",
          phone:""
      };
    },
    estimateAllowedDatesStart(val) {
      if (this.endDate) {
        return val <= moment(this.endDate).format('YYYY-MM-DD') && val > moment(this.endDate).subtract(14, 'days').format('YYYY-MM-DD');
      }
      return val
    },
    estimateAllowedDatesEnd(val) {
      return val < moment(this.startDate).add(14, 'days').format('YYYY-MM-DD');
    },
    handleCancelDate(){
      this.startMenuEstimasi = false
      this.minDate = "" 
      this.maxDate = ""
      this.estimateDate = []
    },
    async updateWaskat(user) {
      await this.$store.dispatch('searchWaskatData', user);
      if (this.waskatData) {
        user.contact = this.waskatData.phone;
        user.email = this.waskatData.email;
      }
      this.waskat = user;
    },
    async updateWaskat2(user) {
      await this.$store.dispatch('searchWaskatData', user);
      if (this.waskatData) {
        user.contact = this.waskatData.phone;
        user.email = this.waskatData.email;
      }
      this.waskat2 = user;
    },
    async updateWaskat3(user) {
      await this.$store.dispatch('searchWaskatData', user);
      if (this.waskatData) {
        user.contact = this.waskatData.phone;
        user.email = this.waskatData.email;
      }
      this.waskat3 = user;
    },
    handleChangeDate(date){
      this.minDate = date[0];
      this.maxDate = moment(date[0]).add(14, "days").format("YYYY-MM-DD")

    },
    filterTime(value) {
      let temp = value.split("");
      if (parseInt(temp[0]) > 2) {
        temp[0] = "2";
      }
      if (parseInt(temp[1]) > 3 && parseInt(temp[0]) == 2) {
        temp[1] = "3";
      }
      if (parseInt(temp[3]) > 5) {
        temp[3] = "5";
      }
      return temp.join("");
    },
    clearDate() {
      this.startMenu = false;
      this.startMenuEstimasi = false;
    },
    formatDate: helper.formatDate,
    scrollTop() {
      window.scrollTo(0, 0);
    },
    closeModal(params){
      this.openModalNotif = params
    },
    handleNextStep(){
      let formData = {
        ktpNumber : this.ipKaryawan.ktpNumber,
        department: this.ipKaryawan.department,
        company: this.company == 'Lain-Lain' ? this.otherCompany : this.company 
      }
      if (this.existingKaryawanId) formData._id = this.existingKaryawanId;
      const config = {
        method: "post",
        url: `${this.API_URL}/v1/requests/checkWaskatOngoing`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.token}`,
        },
        data: formData,
      };
      axios(config).then((res) => {
        const hasExtendSixMonth = res.data.hasExtendSixMonth
        if(hasExtendSixMonth){
          this.ipValidasiWaskat.ipNo = res.data.dataExtendSixMonth.ipNo;
          this.ipValidasiWaskat.department = res.data.dataExtendSixMonth.ipKaryawan.department;
          this.ipValidasiWaskat.ipEstimateEnd = moment(res.data.dataExtendSixMonth.ipEstimateEnd).format('D MMMM YYYY');
          this.dialogInfo = true
          return
        }
        
        
        const result = res.data.hasOngoing;
        if (result == false){
          this.e1 = 3
        }else{
          this.openModalNotif = true
        }
      });
    },
    handleOpenModal(){
      this.$refs.modalEditWaskat1.showData();
      this.openModalEditWaskat = true
    },
    handleOpenModal2(){
      this.$refs.modalEditWaskat2.showData();
      this.openModalEditWaskat2 = true
    },
    handleOpenModal3(){
      this.$refs.modalEditWaskat3.showData();
      this.openModalEditWaskat3 = true
    },
    closeModalEditWaskat(params){
      this.openModalEditWaskat = params
    },
    closeModalEditWaskat2(params){
      this.openModalEditWaskat2 = params
    },
     closeModalEditWaskat3(params){
      this.openModalEditWaskat3 = params
    },
    saveEditWaskat($event){
      this.waskat = $event
    },
    saveEditWaskat2($event){
      this.waskat2 = $event
    },
    saveEditWaskat3($event){
      this.waskat3 = $event
    },
    submit(status) {
      this.status = status;
      let dataWaskat = [{
          waskatId: this.waskat.id,
          name : this.waskat.name,
          email: this.waskat.email,
          phone : this.waskat.contact,
          company : this.waskat.company,
          position : this.waskat.position,
          nik: this.waskat.nik
        },{
          waskatId: this.waskat2.id,
          name : this.waskat2.name,
          email: this.waskat2.email,
          phone : this.waskat2.contact,
          company : this.waskat2.company,
          position : this.waskat2.position,
          nik: this.waskat2.nik
        }]
      if(this.waskat3){
          dataWaskat=[...dataWaskat,{
            waskatId: this.waskat3.id,
            name : this.waskat3.name,
            email: this.waskat3.email,
            phone : this.waskat3.contact,
            company : this.waskat3.company,
            position : this.waskat3.position,
            nik: this.waskat3.nik
          }]
      }

       let formData = {
        ipJudulPekerjaan : this.ipJudulPekerjaan,
        ipJenisPekerjaan : this.ipJenisPekerjaan,
        ipZonaKerja : this.ipZonaKerja,
        ipLocation : this.selectedLoc,
        ipSubLocation : this.ipSubLocation,
        ipEstimateStart : this.startDate,
        ipEstimateEnd : this.endDate,
        ipWaskats :dataWaskat,
        ipKaryawan : this.company !== 'Lain-Lain' ? {...this.ipKaryawan,atasan:{},company : this.company} : {...this.ipKaryawan,atasan:this.atasan,company:this.otherCompany} , 
        ipJobDescription : this.ipJobDescription,
        ipUploadedDocsStatus : this.ipUploadedDocsStatus,
        ipStatus : this.status,
        ipUser : this.dataUsers ,
        ipUploadedDocsId : this.uploadId,
        ipUploadedPhotoId : this.uploadIdPhoto
       }
       if (this.existingKaryawanId) formData.ipKaryawan._id = this.existingKaryawanId;
       const isDraftAndEdit = this.edit;
       if (isDraftAndEdit) formData.ipNo = this.ipNo;
       const config = {
        method: isDraftAndEdit ? "put" : "post",
        url: `${this.API_URL}/v1/requests${isDraftAndEdit ? "/editWaskat" : "/submitWaskat"}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.token}`,
        },
        data: formData,
      };
      axios(config).then((res) => {
        this.$store.commit("temporaryData", res);
        this.$router.push("/my-permit");
      });

    },
    deleteDocPendukung(name) {
      let id = (name === 'photo') ? this.uploadIdPhoto.toString() : this.uploadId.toString();
      this.$store
        .dispatch("deleteFile", {
          uploadId: id,
          folderName: name,
        })
        .then(() => {
          if (name === 'photo') {
            this.photo = null;
          } else {
            this.docPendukung = null;
          }
        })
        .catch(() => {
          this.$snackbar.showMessage({ message: "Delete failed!", color: 'red' });
        });
    },
    backHome() {
      this.$router.push("/my-permit");
    },
    backStep() {
      this.e1--;
    },
    docName(name) {
      return this.$setFilename(name);
    },
  },
  watch: {
    emergencyPhone(params) {
      if (params && params == this.ipKaryawan.phone) {
        this.errorNotif = 'No handphone dan no darurat tidak boleh sama.'
      } else {
        this.errorNotif = null;
      }
    },
    mainPhone(params) {
      if (params && params == this.ipKaryawan.emergencyPhone) {
        this.errorNotif = 'No handphone dan no darurat tidak boleh sama.'
      } else {
        this.errorNotif = ""
      }
    },
    docPendukung(params) {
      if (params && params.size < 10000000) {
        let formData = new FormData();
        formData.append("uploadId", this.uploadId);
        formData.append("docPendukung", params);
        axios.post(
          `${this.API_URL}/v1/requests/attachment/docPendukung`,
          formData,
          { headers: { Authorization: `Bearer ${this.$store.state.token}` } }
        );
      }
    },
    photo(params) {
      if (params && params.size < 10000000) {
        let formData = new FormData();
        formData.append("uploadId", this.uploadIdPhoto);
        formData.append("file", params);
        axios.post(
          `${this.API_URL}/v1/requests/attachment/file/photo`,
          formData,
          { headers: { Authorization: `Bearer ${this.$store.state.token}` } }
        );
      }
    },
    dataJobTypes(params){
      this.jobsTypes = params
    },
    searchName(val){
      const instance = axios.create();
      if(val.length > 3){
        this.isLoadingSearch = true
        instance.post(`${this.API_URL}/v1/employees/findWaskatWorkers`, {
          name: val,
          depts: this.dataUsers.department,
          companies: this.dataUsers.companies,
        },{headers: {"Authorization": `Bearer ${this.$store.state.token}`}})
        .then(res => {
            this.dataKaryawan = [...this.dataKaryawan, ...res.data]
            this.isLoadingSearch = false
        });
      }
    },
    karyawanValues(val){
      this.existingKaryawanId = val._id;
      this.ipKaryawan.ktpNumber = val.ktpNumber 
      this.ipKaryawan.phone = val.phone 
      this.ipKaryawan.emergencyPhone = val.emergencyPhone
      this.ipKaryawan.email = val.email 
      this.ipKaryawan.name = val.name 
      //- this.ipKaryawan.nickname = val.nickname
      this.ipKaryawan.birthPlace = val.birthPlace
      this.ipKaryawan.birthDate = val.birthDate 
      this.ipKaryawan.position = val.position 
      this.ipKaryawan.department = val.department 
      this.ipKaryawan.bloodType = val.bloodType


      const haveAtasan = val.haveAtasan;
      this.company = !haveAtasan ? val.company : 'Lain-Lain';
      if (haveAtasan)  {
        this.atasan.phone = val.atasan.phone;
        this.atasan.email = val.atasan.email;
        this.atasan.name = val.atasan.name;
        this.otherCompany = val.company;
      }
    },
    dataEditRequest: async function () {
      const  {
        // eslint-disable-next-line no-unused-vars
        ipJudulPekerjaan, ipJenisPekerjaan, ipZonaKerja, ipLocation,
        // eslint-disable-next-line no-unused-vars
        ipSubLocation, ipEstimateStart, ipEstimateEnd, ipWaskats,
        // eslint-disable-next-line no-unused-vars
        ipKaryawan, ipJobDescription, ipUploadedDocsStatus, ipUploadedDocsId, ipUploadedPhotoId,
        // eslint-disable-next-line no-unused-vars
        ipUploadedDocs, ipUploadedPhoto, ipNo, _id
      } = this.dataEditRequest;
      
      this.ipJudulPekerjaan = ipJudulPekerjaan;
      this.ipJenisPekerjaan = ipJenisPekerjaan;
      this.ipZonaKerja = ipZonaKerja;
      this.lokasi = ipLocation.map((loc) => loc.name);
      this.ipSubLocation = ipSubLocation;
      this.startDate = moment(ipEstimateStart).format("YYYY-MM-DD");
      this.endDate = moment(ipEstimateEnd).format("YYYY-MM-DD");
      this.waskat = {...ipWaskats[0], id: ipWaskats[0].waskatId, contact: ipWaskats[0].phone};
      this.waskat2 = {...ipWaskats[1], id: ipWaskats[1].waskatId, contact: ipWaskats[1].phone};
      this.waskat3 = ipWaskats[2] ? {...ipWaskats[2], id: ipWaskats[2].waskatId, contact: ipWaskats[2].phone } : "";
      this.ipJobDescription = ipJobDescription;

      const copyKaryawan = { ...ipKaryawan };
      delete copyKaryawan.haveAtasan;
      this.existingKaryawanId = _id;
      this.ipKaryawan = copyKaryawan;
      this.company = ipKaryawan.haveAtasan ? "Lain-Lain" : copyKaryawan.company;
      this.otherCompany = ipKaryawan.haveAtasan ? copyKaryawan.company : "";
      this.atasan = {...this.atasan, ...ipKaryawan.atasan}
      this.dataKaryawan = [ipKaryawan];
      this.karyawanValues = ipKaryawan;

      this.ipUploadedDocsStatus = ipUploadedDocsStatus;

      this.docPendukung = ipUploadedDocs.docPendukung;
      this.photo = ipUploadedPhoto.photo;
      this.uploadId = ipUploadedDocsId;
      this.uploadIdPhoto = ipUploadedPhotoId;
      this.ipNo = ipNo;
    },
  },
};
</script>

<style>
.ck-editor__editable {
  min-height: 300px;
  max-height: 300px;
  resize: none;
}

.mustFill {
  color: #ea5164;
}
</style>
